import { api } from "./client";

export async function downloadApiFile(path: string, filename: string, mimeType: string): Promise<void> {
  const blob = await api.get<Blob>(path, { raw: true, headers: { Accept: mimeType } });
  const url = URL.createObjectURL(blob); const anchor = document.createElement("a");
  anchor.href = url; anchor.download = filename; anchor.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
